import NotFoundView from '@/views/404.vue'
import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import guard from '@/router/guard'
import builder from '@/router/routes/builder'
import buildergpt from '@/router/routes/buildergpt'
import { ProjectIsGPT } from '@/utils/project'

Vue.use(VueRouter)

const currentRoutes =  ProjectIsGPT() ?  buildergpt : builder 
const routes: Array<RouteConfig> = [
  ...currentRoutes,
  {
    path: '*',
    name: '404',
    component: NotFoundView,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

guard(router)

export default router
